import { render } from "./SubscriptionPlanComponent.vue?vue&type=template&id=15873057&scoped=true&ts=true"
import script from "./SubscriptionPlanComponent.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPlanComponent.vue?vue&type=script&lang=ts"

import "./SubscriptionPlanComponent.vue?vue&type=style&index=0&id=15873057&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15873057"]])

export default __exports__